export default __webpack_public_path__ + "static/media/Group 7342.a8020543.svg";